import React from "react";
import { Coffee, MapPin, Clock, BadgeCheck, ShieldCheck, Award } from "lucide-react";
import { SITE } from "../lib/site";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-20 md:py-24 bg-[#F0F7E8]">
      <div className="max-w-6xl mx-auto px-5 md:px-8 grid md:grid-cols-2 gap-12 md:gap-16 items-center">
        <div className="relative">
          <div className="rounded-2xl overflow-hidden border border-[#DCE4EC] bg-white shadow-sm">
            <img
              src={SITE.ownerPhoto}
              alt="The Patient Tech Bloke — smiling, friendly Adelaide IT expert"
              data-testid="about-image"
              className="w-full h-[420px] md:h-[560px] object-cover"
              loading="lazy"
            />
          </div>
          <div className="hidden md:flex absolute -bottom-6 -right-6 bg-white border border-[#DCE4EC] rounded-2xl px-5 py-4 shadow-sm items-center gap-3">
            <div className="w-14 h-14 rounded-full bg-[#0F2E52]/15 grid place-items-center shrink-0">
              <Award className="w-7 h-7 text-[#0F2E52]" strokeWidth={2.5} />
            </div>
            <div>
              <div className="font-[Work_Sans] font-bold text-[#0F2E52] text-lg leading-tight">
                {SITE.yearsExperience}+ years
              </div>
              <div className="text-sm text-[#475569]">Cyber security &amp; IT</div>
            </div>
          </div>
        </div>

        <div>
          <p className="text-base md:text-lg font-semibold text-[#6BAF3C] uppercase tracking-wide">About me</p>
          <h2 className="mt-3 font-[Work_Sans] text-3xl md:text-4xl lg:text-5xl font-bold text-[#0F2E52]">
            G’day — I’m Tom, the Patient Tech Bloke.
          </h2>
          <p className="mt-5 text-lg md:text-xl text-[#1E3A5F] leading-relaxed">
            I’m an <strong>Adelaide local</strong> — born here, lived here all my life. Over the last
            <strong> {SITE.yearsExperience}+ years I’ve worked in IT and cyber security</strong>,
            protecting people’s identities, accounts and devices from scammers
            and hackers. These days, I use that experience to look after fellow
            locals — patiently, in plain English, at your kitchen table.
          </p>
          <p className="mt-4 text-lg md:text-xl text-[#1E3A5F] leading-relaxed">
            The thing I hear most often is, <em>“I’m sorry for asking such a silly
            question.”</em> There are no silly questions here. I’ll happily go over
            it as many times as you need — and I’ll show you how to stay safe
            online for good.
          </p>

          <div className="mt-8 grid sm:grid-cols-2 gap-4">
            <Feature icon={ShieldCheck} title="Cyber security expert" desc="25+ years protecting people’s ID & data." />
            <Feature icon={Coffee} title="Patient & friendly" desc="No rushing, no jargon — promise." />
            <Feature icon={MapPin} title="Adelaide local" desc="I come to you across Adelaide & surrounds." />
            <Feature icon={BadgeCheck} title="Honest pricing" desc="Fair hourly rate, no surprises." />
          </div>
        </div>
      </div>
    </section>
  );
}

function Feature({ icon: Icon, title, desc }) {
  return (
    <div className="flex items-start gap-4 bg-white border border-[#DCE4EC] rounded-xl p-4">
      <div className="w-12 h-12 rounded-lg bg-[#FFFFFF] grid place-items-center shrink-0">
        <Icon className="w-6 h-6 text-[#0F2E52]" strokeWidth={2.2} />
      </div>
      <div>
        <div className="font-[Work_Sans] font-semibold text-lg text-[#0F2E52]">{title}</div>
        <div className="text-base text-[#1E3A5F]">{desc}</div>
      </div>
    </div>
  );
}
